module.exports = fox._r("fonts/robotoslab-regular-webfont.ttf", __webpack_public_path__ + "fonts/2ZaW_U9.ttf");


//////////////////
// WEBPACK FOOTER
// ./fonts/robotoslab-regular-webfont.ttf
// module id = 588
// module chunks = 2